<template>
    <div class="worksHeader">
        <header id="header" class="header">
            <nav class="navbar navbar-default navbar-fixed-top thin">
                <div class="header-container">
                    <!-- Brand and toggle get grouped for better mobile display -->
                    <div class="navbar-header">
                        <button type="button" class="navbar-toggle collapsed" data-toggle="collapse" data-target="#header_collapse" aria-expanded="false">
                            <span class="sr-only">Toggle navigation</span>
                            <span class="icon-bar"></span>
                            <span class="icon-bar"></span>
                            <span class="icon-bar"></span>
                        </button>
                        <a class="navbar-brand" @click="$router.push('/home')">
                            <img :src="themeData.logo? themeData.logo : logo" alt="Law">
                        </a>
                    </div>

                    <div class="collapse navbar-collapse" id="header_collapse">
                        <ul class="nav navbar-nav navbar-right">
                            <li class="current"><a :class="$route.name == 'home'? 'active' : ''" @click="$router.push('/home')">
                                <svg-icon icon-class="home"/>首页</a></li>
                            <li><a :class="$route.name == 'works'? 'active' : ''" @click="$router.push('/works')">
                                <svg-icon icon-class="find"/>发现作品</a></li>
                            <!-- <li>
                                <a class="createworks">
                                    <el-dropdown trigger="click">
                                        <span class="el-dropdown-link">创作</span>
                                        <el-dropdown-menu slot="dropdown" class="dropdownBox">
                                            <el-dropdown-item><a @click="$router.push('/sh')">Scratch</a></el-dropdown-item>
                                            <el-dropdown-item><a :href="`https://${hostName}/py`">Python</a></el-dropdown-item>
                                        </el-dropdown-menu>
                                    </el-dropdown>
                                </a>
                            </li> -->
                            <li><a :class="$route.name == 'sh'? 'active' : ''" @click="goBlock">
                                <svg-icon icon-class="block"/>图形化创作</a>
                            </li>
                            <li><a :class="$route.name == 'py'? 'active' : ''" @click="goPython">
                                <svg-icon icon-class="python"/>Python创作</a>
                            </li>
                            <li><a :class="$route.name == 'match'? 'active' : ''" @click="$router.push('/match')">
                                <svg-icon icon-class="competition"/>竞赛</a>
                            </li>
                            <li v-if="hostName == `roborobo.${institutionConfig.baseDomainName}`"><a :class="$route.name == 'codeActivity'? 'active' : ''" @click="goPlayCode">
                                <svg-icon icon-class="playCode"/>玩转编程日</a>
                            </li>
                            <!-- <li v-if="!loginBtnShow && this.hostName!=`kexie.${institutionConfig.baseDomainName}`"><a :class="$route.name == 'lesson'? 'active' : ''" @click="$router.push('/lesson')">我的课程</a></li> -->
                            <li v-if="hostName==`kexie.${institutionConfig.baseDomainName}`"><a :class="$route.name == 'lesson'? 'active' : ''" @click="gotoRoboClass()">
                                <svg-icon icon-class="lesson"/>课程</a>
                            </li>
                            <!-- <li v-if="!loginBtnShow"><a :class="$route.name == 'myexam'? 'active' : ''" @click="$router.push('/myexam')">我的考试</a></li> -->
                            <!-- <li v-if="!loginBtnShow && this.hostName!=`roborobo.${institutionConfig.baseDomainName}` && this.hostName!=`kexie.${institutionConfig.baseDomainName}`"><a :class="$route.name == 'cpa'? 'active' : ''" @click="loginToCpa()">考级报名</a></li> -->
                            <!-- <li v-if="!loginBtnShow"><a :class="$route.name == 'myworks'? 'active' : ''" @click="$router.push('/mywork')">我的作品</a></li> -->
                            <!-- <li v-if="!loginBtnShow"><a :class="$route.name == 'personhome'? 'active' : ''" @click="goPersonHome">个人主页</a></li> -->
                            <li><a :class="$route.name == 'personhome'? 'active' : ''" @click="goPersonHome">
                                <svg-icon icon-class="my"/>我</a>
                            </li>
                            <li v-if="hostName!=`roborobo.${institutionConfig.baseDomainName}` && showDownload"><a :class="$route.name == 'download'? 'active' : ''" @click="$router.push('/download')">
                                <svg-icon icon-class="download"/>软件下载</a></li>
                            <li>
                                <a  v-if="loginBtnShow" @click="loginShow">登录 / 注册</a>
                                <div v-else class="userIcon">
                                    <el-dropdown  trigger='click'>
                                        <img :src="userInfo.avatar? `http://static.${institutionConfig.baseDomainName}/noavatar.png` : `http://static.${institutionConfig.baseDomainName}/noavatar.png`" alt="">            
                                        <el-dropdown-menu slot="dropdown" class="headerComponent">
                                            <!-- <el-dropdown-item @click.native="goMyWorks"><i class="el-icon-user" ></i>我的项目</el-dropdown-item>
                                            <el-dropdown-item @click.native="goPersonHome"><i class="el-icon-s-home"></i>个人主页</el-dropdown-item> -->
                                            <el-dropdown-item @click.native="changePassword"><i class="el-icon-setting"></i>修改密码</el-dropdown-item>
                                            <el-dropdown-item divided @click.native="logout"><i class="el-icon-warning-outline"></i>退出登录</el-dropdown-item>
                                        </el-dropdown-menu>
                                    </el-dropdown>
                                </div>
                            </li>
                            <li v-if="isBtnShow"><a :href="`https://${hostName}/psp`">
                                <svg-icon icon-class="system"/>后台管理系统</a></li>
                            <!-- <li v-if="isBtnShow"><a :href="`https://psp.${institutionConfig.baseDomainName}/setTokenLogin?t=${token}`">后台管理系统</a></li> -->
                        </ul>
                    </div>
                </div>
            </nav>
        </header> <!-- /#header -->
        <Login></Login>
    </div>
</template>

<script>
import Operation from "../request";
import communityApi from "@/request/api/community";
import userApi from "@/request/api/user";
import Login from '@/components/loginDialog';

export default {
    components: { Login },
    computed: {
        userInfo() {
            return this.$store.state.userInfo;
        },
        loginBtnShow() {
            return this.$store.state.loginBtnShow;
        },
        themeData() {
            return this.$store.state.themeData;
        },
        scratchLogout() {
            return this.$store.state.scratchLogout;
        },
        pythonLogin() {
            return this.$store.state.pythonLogin
        },
    },
    data () {
        return {
            token: userApi.getToken(),
            logo: require("@/assets/images/logo.png"), //logo
            isBtnShow: false, //后台入口显隐
            showDownload:true,//是否显示客户端下载页面
            hostName: location.hostname,
            timer: null,
        }
    },
    watch: {
        userInfo() {
            this.systemBtnShow();
        }
    },
    created() {
        if(this.$route.query && this.$route.query.change) {
            this.$store.commit('setChangeDialogVisible', false)
        }
        if(this.$route.query && this.$route.query.channel && this.$route.query.channel=='vipcode'){
            this.showDownload = false
        }
        this.systemBtnShow();
        // this.getUserInfo();
    },
    methods: {
        loginToCpa(){
            communityApi.loginToCpa(res =>{
                if(res.succeed){
                    Operation.SessionStorage.set('cpaToken', res.data)
                    this.$router.push('/cpa')
                }
            })
        },
        //点击登录显示弹框
        loginShow() {
            if(this.loginBtnShow) {
                this.$store.commit('setDialogVisible', true)
            }
        },
        //token之后获取用户信息
        // getUserInfo() {
        //     if(userApi.getToken() && !this.$store.state.userInfo.id) {
        //         userApi.getCurrentUser(res => {
        //             if(res.succeed) {
        //                 this.$store.commit('setDialogVisible', false)
        //                 this.$store.commit('setUserInfo', res.data)
        //                 this.$store.commit('setLoginBtnShow', false)
        //             }
        //         })
        //     }
        // },
        //显示psp按钮
        systemBtnShow() {
            if(this.userInfo && this.userInfo.roles) {
                if(this.userInfo.roles.join("").indexOf("机构管理员") > -1 || this.userInfo.roles.join("").indexOf("系统管理员") > -1) {
                    this.isBtnShow = true;
                }
            }
        },
        //退出登录
        logout() {
            userApi.deleteToken();
            this.isBtnShow = false;
            this.$store.commit('setUserInfo', null)
            this.$store.commit('setLoginBtnShow', true)
            if(this.$route.name == 'sh') this.scratchLogout();
            else if(this.$route.name == "py") this.pythonLogin();
            else if(this.$route.name == 'testPaper') this.$router.replace('/home')
        },
        //前往图形化创作
        goBlock() {
            this.$router.push('/sh');
            this.loginShow();
        },
        //前往python创作
        goPython() {
            this.$router.push('/py');
            this.loginShow();
        },
        //我的项目
        goMyWorks() {
            this.$router.push('/mywork')
        },
        //个人主页
        goPersonHome() {
            if(this.loginBtnShow) {
                this.loginShow();
                this.$store.commit('setCallback', () => {
                    this.$router.push('/personhome')
                });
            } else {
                this.$router.push('/personhome')
            }
        },
        goPlayCode() {
            this.$router.push('/codeActivity');
            // this.loginShow();
        },
        //修改密码
        changePassword() {
            this.$store.commit('setChangeDialogVisible', true);
        },
        gotoRoboClass(){
            window.location.href='http://18510013180.test.edusoho.cn/';
        }
    }
}
</script>

<style scoped>
    
    .el-dropdown-link {
        padding: 10px;
    }
    .el-dropdown-menu {
        /* top: 40px !important; */
        margin-top: 15px !important; 
        color: var(--theme-fontColor) !important;
        background-color: var(--theme-color) !important;
        border: 1px solid var(--theme-color) !important;
    }
    .el-dropdown-menu--small .el-dropdown-menu__item {
        color: var(--theme-fontColor) !important;
        padding: 0 8px !important;
    }
    .el-dropdown-menu--small .el-dropdown-menu__item a {
        padding: 5px 15px !important;
    }
    .el-dropdown-menu__item:hover a {
        color: var(--theme-fontColor) !important;
    }
    .el-dropdown-menu__item:focus, .el-dropdown-menu__item:not(.is-disabled):hover {
        color: var(--theme-fontColor) !important;
        background-color: rgba(0, 0, 0, .3) !important;
    }
    .el-dropdown-menu__item--divided:before {
        content: none !important;
    }
    .navbar-toggle {
        background-color: var(--theme-color) !important;
    }
    .el-dropdown {
        height: 100%;
        color: var(--theme-fontColor);
        cursor: pointer;
    }
    
</style>
<style lang="scss">
:root {
  --theme-color: #81D8D0;
  --theme-fontColor: #000;
  --theme-activeColor: var(--theme-color)
}
.headerComponent{
    .popper__arrow::after {
        border-bottom-color:var(--theme-color) !important;
    }
}
.dropdownBox {
    top: 40px;
}
.worksHeader {
    .header-container {
        margin: 0 15px;
    }
    .navbar-nav li a{
        padding: 15px 13px;
    }
    .navbar-right {
        margin-right: 0;
    }
    
    .createworks {
        padding: 15px 5px;
    }
    .navbar-default .navbar-nav > li > a {
        width: 100%;
        color: var(--theme-fontColor);
    }
    #header {
        padding: 25px 0;
    }
    .nav li {
        display: flex;
        flex-direction: row;
        justify-content: center;
    }
    .thin {
        background-color: var(--theme-color);
    }
    .thin.navbar-default .navbar-nav > li > a:hover {
        background: rgba(0, 0, 0, .3) !important;
        color: var(--theme-fontColor) !important;
    }
    .thin.navbar-default .navbar-nav > li > a.active {
        background: rgba(0, 0, 0, .3) !important;
        color: var(--theme-fontColor) !important;
    }
    
    .headerLeft {
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        justify-content: flex-start;
        align-items: center;
    }
    .userIcon {
        width: 35px;
        height: 35px;
        margin: 8px 0 0 5px;
        border-radius: 8px;
        border: 1px solid #fff;
        background: #fff;
        text-align: center;
        overflow: hidden;
        cursor: pointer;
    }
    .userIcon img {
        width: 100%;
        height: 100%;
    }
    .navList .router-link-active {
        background-image: url("../assets/nav_active.png");
        background-size: 70px 5px;
        background-repeat: no-repeat;
        background-position: center bottom;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/header.vue